import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=de9f13de&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=de9f13de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9f13de",
  null
  
)

export default component.exports